module.exports = __webpack_public_path__ + "img/phoenix-framework.5aa20766.svg";